import { memo } from 'react';

import { type Board } from '@air/api/types';
import { ChevronDownIcon, ChevronRightIcon } from '@air/design-icons';

import { type DraggingItems } from '~/components/Shared/Drag/dragTypes';

export type NavBoardDragPreviewProps = {
  board: DraggingItems<Board>;
};

export const NavBoardDragPreview = memo(({ board }: NavBoardDragPreviewProps) => {
  return (
    <div className="flex ui2026:min-h-8 w-60 items-center ui2026:gap-1 rounded-2 ui2026:rounded-8 bg-gray-3 px-2 py-1.5 ui2026:py-1 shadow-drag-preview">
      <ChevronRightIcon size="sm" className="mr-2 ui2026:hidden shrink-0 text-gray-10" />
      <span className="ui2026:flex hidden size-6 shrink-0 items-center justify-center">
        <ChevronDownIcon aria-hidden className="-rotate-90 text-gray-9" size="xs" />
      </span>
      <div className="truncate text-14 text-gray-11 ui2026:text-gray-10">{board.firstItem.title}</div>
    </div>
  );
});

NavBoardDragPreview.displayName = 'NavBoardDragPreview';
